export default __webpack_public_path__ + "static/media/menu-cross.c2aa1d97.svg";